export default __webpack_public_path__ + "images/public/images/envelopamento-automotivo.jpg";